export default class ServiceProvider {
    constructor(searchService) {
        this._searchService = searchService;
    }
    get searchService() {
        return this._searchService;
    }
}
